module.exports = __webpack_public_path__ + "static/img/otherback.8e933c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/otherback.png
// module id = P45+
// module chunks = 1